import styled from 'styled-components';
import color from 'tinycolor2';

export const ScrollWrapper = styled.div`
  overflow: auto;
  max-height: calc(100vh - 80px);
  max-width: 100%;
  height: 100%;
  display: inline-flex;
  border-radius: 4px;
  box-shadow: ${(props) => props.theme['shadow.card']};
  background: ${(props) => props.theme['color.surface']};
  position: relative;
`;

export const Table = styled.table`
  border-collapse: collapse;
  color: ${(props) => props.theme['color.text.body']};
  font-size: 14px;
  padding-top: 40px;
`;

export const TableRow = styled.tr`
  height: 44px;
  position: relative;
`;

export const TableCell = styled.td`
  text-align: center;
  min-width: 200px;
`;

export const TableHeaderCell = styled.th`
  position: sticky;
  top: 0;
  left: 0;
  text-align: center;
  min-width: 200px;
  background: ${(props) => props.theme['color.surface']};
  font-weight: 400;
`;

export const TableHead = styled.thead`
  ${TableHeaderCell} {
    z-index: 16;
    padding: 10px;
    box-shadow: inset 0 -1px 0 0 ${(props) => props.theme['color.border']};
  }

  ${TableHeaderCell}:first-child {
    z-index: 32;

    &::after {
      content: '';
      border-right: 1px solid ${(props) => props.theme['color.border']};
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
`;

export const TableBody = styled.tbody`
  ${TableRow} {
    border-top: 1px solid ${(props) => color(props.theme['color.border']).setAlpha(color(props.theme['color.border']).getAlpha() * 0.5).toString()};
  }

  ${TableRow}:first-child {
    border: 0;
  }

  ${TableHeaderCell} {
    padding: 0 16px;
    box-shadow: inset -1px 0 0 0 ${(props) => props.theme['color.border']};
  }
`;
